import type { ContentRegistry } from '@/core/content/registry';
import type { ShootCriterion } from '@/core/content/schemas/studio';
import type { TFunction } from '@/core/i18n/translator';

/** One checklist line of a Studio brief, in plain words (studio-nano.md §4.2). */
export function criterionText(c: ShootCriterion, t: TFunction, content: ContentRegistry): string {
  switch (c.type) {
    case 'theme':
      return t('studio.crit.theme', { count: c.count, theme: t(`studio.theme.${c.tag}`) });
    case 'tag':
      return t(`studio.crit.tag.${c.tag}`, { count: c.count });
    case 'item':
      return t(content.items.get(c.itemId)?.nameKey ?? '');
    case 'wallFloor':
      return t('studio.crit.wall_floor', {
        names: c.ids.map((id) => t(content.wallFloors.get(id)?.nameKey ?? '')).join(t('studio.crit.or')),
      });
    case 'cozy':
      return t('studio.crit.cozy', { points: c.points });
  }
}
